/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_Add_LocationInputs */

const en_ats_tip_add_location = /** @type {(inputs: Ats_Tip_Add_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add your location or portfolio URL`)
};

const de_ats_tip_add_location = /** @type {(inputs: Ats_Tip_Add_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge deinen Standort oder deine Portfolio-URL hinzu`)
};

const fr_ats_tip_add_location = /** @type {(inputs: Ats_Tip_Add_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez votre localisation ou l'URL de votre portfolio`)
};

const es_ats_tip_add_location = /** @type {(inputs: Ats_Tip_Add_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade tu ubicación o URL de portfolio`)
};

const it_ats_tip_add_location = /** @type {(inputs: Ats_Tip_Add_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi la tua posizione o l'URL del portfolio`)
};

const nl_ats_tip_add_location = /** @type {(inputs: Ats_Tip_Add_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg je locatie of portfolio-URL toe`)
};

const pl_ats_tip_add_location = /** @type {(inputs: Ats_Tip_Add_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj swoją lokalizację lub adres URL portfolio`)
};

const fi_ats_tip_add_location = /** @type {(inputs: Ats_Tip_Add_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää sijaintisi tai portfolio-URL`)
};

const da_ats_tip_add_location = /** @type {(inputs: Ats_Tip_Add_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj din placering eller portfolio-URL`)
};

const sv_ats_tip_add_location = /** @type {(inputs: Ats_Tip_Add_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till din plats eller portfolio-URL`)
};

/**
* | output |
* | --- |
* | "Add your location or portfolio URL" |
*
* @param {Ats_Tip_Add_LocationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_add_location = /** @type {((inputs?: Ats_Tip_Add_LocationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_Add_LocationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_add_location(inputs)
	if (locale === "fr") return fr_ats_tip_add_location(inputs)
	if (locale === "es") return es_ats_tip_add_location(inputs)
	if (locale === "it") return it_ats_tip_add_location(inputs)
	if (locale === "nl") return nl_ats_tip_add_location(inputs)
	if (locale === "pl") return pl_ats_tip_add_location(inputs)
	if (locale === "fi") return fi_ats_tip_add_location(inputs)
	if (locale === "da") return da_ats_tip_add_location(inputs)
	if (locale === "sv") return sv_ats_tip_add_location(inputs)
	return en_ats_tip_add_location(inputs)
});